(function(){
    angular
        .module('app')
        .directive('openStreetMaps', openStreetMaps);


        openStreetMaps.$inject = ['$timeout'];
        function openStreetMaps($timeout){
            return {
              scope:{
                options:"=",
                markers:"="
              },
            link: function (scope, element, $attrs) {
                var options = {};
                if(scope.options){
                    options = scope.options;
                    options.fit = (options.fit)?options.fit:false
                }
                var $element = $(element);
                var name = $element.attr("id");
                var map = null;
                var markers = [];

                var markerLayer = [];
                var overlays = [];
                var vectorSource = null;
                var initLayout = false;

                console.log(scope.markers);
                var removeMarkers = function()
                {
                    markers = [] ;
                    if(vectorSource){
                        vectorSource.clear();
                        angular.forEach(markers,function(f,key){
                            //vectorSource.removeFeature(value);
                            markerLayer.getSource().addFeature(f);
                        });
                        map.getOverlays().clear() 
                    }

                }
                function createElementFromHTML(htmlString) {
                  var div = document.createElement('div');
                  div.innerHTML = htmlString.trim();

                  // Change this to div.childNodes to support multiple top-level nodes.
                  return div.childNodes[0];
                }
                const createOverlay = function(identifier,city,lon,lat)
                {
                    var buttonElement =  createElementFromHTML('<button type="button" class="overlay c-btn c-btn__primary" >'+city+'</button>')
                    
                    const overlay = new ol.Overlay({
                      id:identifier,
                      position:ol.proj.fromLonLat([lon, lat]),
                      positioning: 'bottom-center',
                      element:buttonElement,
                      stopEvent: false,
                      offset:[0,85]
                    });
                    overlays.push(overlay);

                    jQuery(buttonElement).on("click",function(evt) {
                        angular.forEach(markers, function(f,key){
                            if(f.getId() == identifier)
                                scope.$emit('markerClick',f);
                        })
                    });
                    //map.addOverlay(overlay);
                    
                    return overlay;
                }

                var createMarkerFeature = function(identifier,img,lon,lat,overlay){
                    if(!(identifier && img && lon && lat))
                        return ;

                    var markerGeometry = new ol.geom.Point(ol.proj.fromLonLat([lon, lat]));
                    var markerFeature = new ol.Feature({
                        name:identifier,
                        geometry: markerGeometry,
                        
                    });
                    markerFeature.setProperties({overlay:overlay});
                    markerFeature.setId(identifier);
                    var markerStyle = new ol.style.Icon(({
                        src: img
                    }));

                    markerFeature.setStyle(new ol.style.Style({
                        image: markerStyle,
                    }));                

                    markers.push(markerFeature);
                }

                var addLayerVector = function()
                {
                    if(!markers.length) 
                        return;

                
                    if(options.markerCluster )
                    {
                        vectorSource = new ol.source.Vector({
                            features: markers
                        });

                        var azul = "#291a63";

                        var clusterSource = new ol.source.Cluster({
                            distance: (options.distance)?options.distance:30,                           
                            source: vectorSource,
                        });

                        var styleCache = {};
                        markerLayer = new ol.layer.AnimatedCluster({
                          source: clusterSource,
                          animationDuration: 700,
                           style: function (feature) {

                                const size = feature.get('features').length;



                                if(size>1){
                                    angular.forEach(feature.get('features'),function(value,key){
                                        if(value.getProperties().overlay)
                                        {
                                            map.removeOverlay(value.getProperties().overlay);
                                        }
                                    });
                                    var color = azul;

                                    var style = styleCache[size];
                                    if (!style) {
                                      style = new ol.style.Style({
                                        image: new ol.style.Circle({
                                          radius: (options.radius)?options.radius:20,
                                          stroke: new ol.style.Stroke({
                                            color: '#fff',
                                          }),
                                          fill: new ol.style.Fill({
                                            color: color,
                                          }),
                                        }),
                                        text: new ol.style.Text({
                                          text: size.toString(),
                                          fill: new ol.style.Fill({
                                            color: '#fff',
                                          }),
                                        }),
                                      });
                                      styleCache[size] = style;
                                    }
                                    return style;
                                }
                                else{
                                    
                                    if(feature.get('features')[0].getProperties().overlay)
                                        map.addOverlay(feature.get('features')[0].getProperties().overlay);

                                    
                                    return feature.get('features')[0].getStyle();
                                }
                              },
                          
                        });
                        map.addLayer(markerLayer);
                        if(options.fit && initLayout){
                            const extent = new ol.extent.boundingExtent(
                               markers.map((r) => r.getGeometry().getCoordinates())
                            );        
                            map.getView().fit(extent, {duration: 1000, padding: (options.padding)?options.padding:[40, 40, 40, 40]});
                        }

                        
                    }else{
                        vectorSource = new ol.source.Vector({});
                    
                        markerLayer = new ol.layer.Vector({
                            source: vectorSource
                        });
                        if(options.fit && initLayout){
                            map.addLayer(markerLayer);
                                const extent = new ol.extent.boundingExtent(
                                   markers.map((r) => r.getGeometry().getCoordinates())
                            );        
                            map.getView().fit(extent, {duration: 1000, padding: (options.padding)?options.padding:[40, 40, 40, 40]});
                        }

                            angular.forEach(markers, function(f,key){
                                $timeout(function(){
                                markerLayer.getSource().addFeature(f);
                                markerLayer.animateFeature (f, [
                                new ol.featureAnimation["Drop"]({
                                    speed: 1, 
                                    duration: 500,
                                    sid:true
                                })
                              ]);

                            });
                        });
                        
                    }
                    initLayout = true;
                    
                    
                }




                return $timeout(function () {

                    var layers = [
                         new ol.layer.Tile({
                             source: new ol.source.OSM({
                                className: 'bw',
                                maxZoom: (options.maxZoom)?options.maxZoom:19,
                                minZoom: (options.minZoom)?options.minZoom:0,
                                

                             })
                         }),
                     ];
                     var layer = layers[0];

                     var filter = new ol.filter.Colorize();
                     
                     filter.setFilter({ 
                        operation:'greyscale',
                        red:100,
                        blue:100,
                        green:100,
                        value:1
                     });

                     
                     layer.addFilter(filter);

                  
                         map = new ol.Map({     
                             layers: layers,
                             target: 'map',
                             view: new ol.View({
                                 center: ol.proj.fromLonLat([(options.long)?options.long:-3.7038761999149656, (options.lat)?options.lat:40.41686295]),
                                 maxZoom: (options.maxZoom)?options.maxZoom:19,
                                 minZoom: (options.minZoom)?options.minZoom:0,
                                 zoom: (options.zoom)?options.zoom:3,
                             }),
                             interactions: ol.interaction.defaults.defaults({
                                doubleClickZoom: (options.doubleClickZoom)?options.doubleClickZoom:true,
                                dragAndDrop: (options.dragAndDrop)?options.dragAndDrop:true,
                                dragPan: (options.dragPan)?options.dragPan:true,
                                keyboardPan: (options.keyboardPan)?options.keyboardPan:true,
                                keyboardZoom: (options.keyboardZoom)?options.keyboardZoom:true,
                                mouseWheelZoom: (options.mouseWheelZoom)?options.mouseWheelZoom:false,
                                pointer: (options.pointer)?options.pointer:true,
                                select: (options.select)?options.select:true
                              }),
                         });

                         



                        map.on('singleclick', function (evt) {
                            if(options.markerCluster){
                                markerLayer.getFeatures(evt.pixel).then((clickedFeatures) => {
                                    if (clickedFeatures.length) {
                                      // Get clustered Coordinates
                                      const features = clickedFeatures[0].get('features');
                                      if (features.length > 1) {        
                                        
                                        const extent = new ol.extent.boundingExtent(
                                          features.map((r) => r.getGeometry().getCoordinates())
                                        );        
                                        map.getView().fit(extent, {duration: 1000, padding: (options.padding)?options.padding:[150, 150, 150, 150]});
                                      }else{
                                        const extent = new ol.extent.boundingExtent(
                                          features.map((r) => r.getGeometry().getCoordinates())
                                        );        
                                        map.getView().fit(extent, {duration: 1000, padding: [1300, 1300, 1300, 1300] });
                                         scope.$emit('markerClick',features[0]);
                                      }
                                    }
                                });
                            }else{

                                evt.map.forEachFeatureAtPixel(evt.pixel, function(layer) {                      
                                    scope.$emit('markerClick',layer);
                                });
                            }


                        });

                        scope.$watch("markers",function()
                        {
                            console.log(scope.markers);
                            removeMarkers();
                            angular.forEach(scope.markers,function(value,key){
                                var img = (value.thumb)?value.thumb:value.img;
                                var overlay = null;
                                

                                createMarkerFeature(value.url_map,img,value.long_map,value.lat_map,overlay);

                            });
                            addLayerVector();

                        });
                
                });
            }
          }
      }
})();